import { FC } from 'react';
import Head from 'next/head';

export interface HeadProps {
	title: string;
	description: string;
	lang?: string;
	keywords?: string;
	author?: string;
	image?: string;
	meta?: Array<{
		name: string;
		content: string;
	}>;
}

const SeoHead: FC<HeadProps> = ({
	title,
	description,
	author = 'Junaid Umer',
	keywords,
	image = 'https://res.cloudinary.com/jacobherper/image/upload/c_fill,g_north,h_1080,w_1920/v1587315694/herper-io.png ',
	meta,
}) => {
	return (
		<Head>
			<title>{title}</title>
			<meta name="description" content={description} />
			<meta name="author" content={author} />
			<meta name="og:title" content={title} />
			<meta name="og:description" content={description} />
			<meta name="og:type" content="website" />
			<meta name="og:url" content="https://junaidumer.netlify.app/" />
			<meta name="twitter:card" content="summary" />
			<meta name="twitter:title" content={title} />
			<meta name="twitter:description" content={description} />
			<meta name="twitter:creator" content={author} />
			{meta &&
				meta.length > 0 &&
				meta.map(({ name, content }) => (
					<meta name={name} content={content} key={name} />
				))}
			{image && <meta name="og:image" content={image} />}
			{image && <meta name="twitter:image" content={image} />}
			{keywords && <meta name="keywords" content={keywords} />}
			<script
				type="application/ld+json"
				dangerouslySetInnerHTML={{
					__html: `{"@context":"http://schema.org","@type":"WebSite","name":"junaidumer.netlify.app/","alternateName":"Junaid Umer","url":"https://junaidumer.netlify.app/","description":"I develop iOS Applications in Swift language. I am a strong engineering professional with a Master's focus in Information Technology from the University of Sargodha. I have 4+ years of experience in iOS development working with many frameworks like Uikit, UlFoundation. Mobile Core Services, WebKit. AV Foundation, Core Data, Firebase, REST APIs, User Authentication using Facebook, Twitter. Gmail, Google-Plus, and integrated payment methods using PayPal and Stripe. In my professional field, I have worked on about 10 iOS apps.","image":"${image}"}`,
				}}
			/>
			<script
				type="application/ld+json"
				dangerouslySetInnerHTML={{
					__html: `{"@context":"http://schema.org","@type":"WebSite","name":"junaidumer.netlify.app/","alternateName":"Junaid Umer","url":"https://junaidumer.netlify.app/","description":"I develop iOS Applications in Swift language. I am a strong engineering professional with a Master's focus in Information Technology from the University of Sargodha. I have 4+ years of experience in iOS development working with many frameworks like Uikit, UlFoundation. Mobile Core Services, WebKit. AV Foundation, Core Data, Firebase, REST APIs, User Authentication using Facebook, Twitter. Gmail, Google-Plus, and integrated payment methods using PayPal and Stripe. In my professional field, I have worked on about 10 iOS apps.","image":"${image}"}`,
				}}
			/>
		</Head>
	);
};

export { SeoHead };
